import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        position: "relative"
    },
    noImageContainer: {
        justifyContent: "center",
        alignItems: "center"
    }
});
export default stylesheet;
